import React from "react";
import { overlayBase } from "./_shared";

interface Props {
  /** Opacity intensity 0–1, default 0.45 */
  intensity?: number;
  /** Frost colour (rgba), default icy blue-white */
  color?: string;
  /** Pulse cycle duration seconds, default 6 */
  dur?: number;
}

/**
 * Frost — crystalline cold creeping in from the corners via radial gradients.
 */
const Frost: React.FC<Props> = ({
  intensity = 0.45,
  color = "rgba(210,235,255,0.8)",
  dur = 6,
}) => (
  <div style={overlayBase}>
    <style>{`
      @keyframes oot-frost {
        0%, 100% { opacity: ${intensity * 0.6}; }
        50%       { opacity: ${intensity}; }
      }
    `}</style>
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `
          radial-gradient(circle at 0%   0%,   ${color}, transparent 38%),
          radial-gradient(circle at 100% 0%,   ${color}, transparent 38%),
          radial-gradient(circle at 0%   100%, ${color}, transparent 38%),
          radial-gradient(circle at 100% 100%, ${color}, transparent 38%)`,
        animation: `oot-frost ${dur}s ease-in-out infinite`,
      }}
    />
  </div>
);

export default Frost;
